/* eslint-disable no-throw-literal */
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useToast,
} from "@chakra-ui/react";
import { Formik } from "formik";
import numeral from "numeral";
import React from "react";
import { HiOutlineChevronLeft } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import * as Yup from "yup";
import SolidButton from "../components/buttons/solidButton";
import CheckBox from "../components/input/checkBox";
import InputField from "../components/input/inputField";
import MobileInputField from "../components/input/mobileInputField";
import Container from "../components/layout/container";
import BottomSection from "../components/sections/bottomSection";
import MiddleSection from "../components/sections/middleSection";
import TopSection from "../components/sections/topSection";
import {
  AIRTEL_REGEX,
  constants,
  SAFARICOM_REGEX,
} from "../constants/constants";
import checkoutState from "../recoil/checkoutState";
import payloadState from "../recoil/payloadState";
import uiState from "../recoil/uiState";
import cleanKenyaPhoneNumber from "../util/cleanKenyaPhoneNumber";
import cleanTanzaniaPhoneNumber from "../util/cleanTanzaniaPhoneNumber";
import { formatPhoneNumber } from "../util/helpers";
import instructionState from "../recoil/instructionState";

// Helper function to render instruction step with replacements
// Note: Uses dangerouslySetInnerHTML to render formatting tags like <strong>.
// Ensure the source of instructions is trusted to prevent XSS vulnerabilities.
const renderInstructionStep = (step, payload) => {
  const accountNumber = payload?.checkout_reference;
  const currency =
    payload.merchant_site_data.running_amounts.converted_currency ??
    payload.merchant_site_data.running_amounts.origin_currency_code;
  const amount = numeral(
    payload.merchant_site_data.running_amounts.converted_balance ??
      payload.merchant_site_data.running_amounts.origin_balance
  ).format("0,0.00");
  // Placeholder for a potentially dynamic paybill number, defaulting to MPESA for now
  const paybillNumber = "260260"; // TODO: Make this dynamic if needed

  // Replace placeholders within the instruction step string
  let renderedStep = step
    .replace(/{account_number}/g, `<strong>${accountNumber}</strong>`)
    .replace(/{amount}/g, `<strong>${amount}</strong>`)
    .replace(/{currency}/g, `<strong>${currency}</strong>`)
    .replace(/{currency_amount}/g, `<strong>${currency} ${amount}</strong>`)
    .replace(/{paybill_number}/g, `<strong>${paybillNumber}</strong>`);

  return <span dangerouslySetInnerHTML={{ __html: renderedStep }} />;
};

function MobileMoneyPage() {
  const toast = useToast();
  const navigate = useNavigate();
  const ui = useRecoilValue(uiState);
  console.log("The selected country in Mobile Money Page", ui.selectedCountry);
  const payload = useRecoilValue(payloadState);
  const [checkout, setCheckout] = useRecoilState(checkoutState);

  const instruction = useRecoilValue(instructionState);
  console.log("The instruction in Mobile Money Page", instruction);

  // Find the instructions for the current payment method and split into steps
  const currentPaymentMethodDetails = instruction?.find(
    (method) => method.payment_method_code === checkout.payment_method_code
  );
  const listOfInstruction =
    currentPaymentMethodDetails?.payment_method_instructions
      ?.split(";")
      .filter((step) => step.trim() !== "") || // Remove empty strings from split
    []; // Default to empty array if not found or null

  // Determine if the "How to Pay" tab should be shown
  const showHowToPayTab = listOfInstruction.length > 0;

  let initialPhoneNumber = (
    payload.merchant_site_data.msisdn
      ? payload.merchant_site_data.msisdn
      : localStorage.getItem("mobileNumber") ?? ""
  ).replace("+", "");

  if (!initialPhoneNumber.startsWith(ui.selectedCountry?.phone_code))
    initialPhoneNumber = "";
  else {
    if (
      checkout.payment_method_code === "MPESA_KEN" &&
      !SAFARICOM_REGEX.test(initialPhoneNumber)
    ) {
      initialPhoneNumber = "";
    }
    if (
      checkout.payment_method_code === "AIRTEL_KEN" &&
      !AIRTEL_REGEX.test(initialPhoneNumber)
    ) {
      initialPhoneNumber = "";
    }
    initialPhoneNumber = initialPhoneNumber.replace(
      ui.selectedCountry?.phone_code,
      ""
    );
  }

  const initialValues = {
    mobileNumber: initialPhoneNumber,
    amount: numeral(
      payload.merchant_site_data.running_amounts.converted_balance ??
        payload.merchant_site_data.running_amounts.origin_balance
    ).format("0.00"),
    saveNumber: false,
  };

  const validatePhoneNumber = (value) => {
    if (value == null || value === undefined) return false;
  };

  const validationSchema = Yup.object({
    mobileNumber: Yup.number("Invalid phone number").required("Required"),
    // .test(
    //   "phoneNumberValidation",
    //   "Invalid phone number",
    //   validatePhoneNumber
    // ),
    amount: Yup.number().required("Required"),
    saveNumber: Yup.bool(),
  });

  const onSubmit = (values, { setSubmitting }) => {
    try {
      let cleanedNumber = values.mobileNumber;

      if (
        checkout.payment_method_code === "MPESA_KEN" ||
        checkout.payment_method_code === "AIRTEL_KEN"
      ) {
        const result = cleanKenyaPhoneNumber(values.mobileNumber);
        if (result.error) {
          throw { message: result.error };
        }
        cleanedNumber = result.cleanedNumber;
      } else if (checkout.payment_method_code === "MPESA_TZA") {
        const result = cleanTanzaniaPhoneNumber(values.mobileNumber);
        if (result.error) {
          throw { message: result.error };
        }
        cleanedNumber = result.cleanedNumber;
      }

      // Proceed if valid
      setCheckout((prevState) => ({
        ...prevState,
        payer_msisdn: cleanedNumber,
        request_amount: values.amount,
        client_service_code:
          payload.merchant_site_data.client_service.client_service_code,
      }));

      if (values.saveNumber) {
        localStorage.setItem("mobileNumber", values.mobileNumber);
      }

      navigate("/authorize-payment");
    } catch (error) {
      toast({
        description: error.message,
        status: "error",
        duration: constants.TOAST_DURATION,
        position: constants.TOAST_POSITION,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const tabs = ["STK Push"];
  // if (checkout.payment_method_code === "MPESA_KEN") { // Commented out as requested
  //   tabs.push("How to Pay"); // Commented out as requested
  // }

  // Commented out as requested: Check if instructions exist to add the tab
  // if (showHowToPayTab) {
  //   tabs.push("How to Pay");
  // }

  return (
    <Container>
      <div>
        <TopSection />
        <MiddleSection />
        <div className="-mt-8 space-y-2 rounded-t-xl bg-white p-4 sm:p-6">
          <div className="relative">
            <Link to="/">
              <HiOutlineChevronLeft className="absolute inset-y-0 left-0 h-full w-5 cursor-pointer text-black" />
            </Link>
            <h2 className="text-center font-medium">{`Pay with ${checkout.payment_method_name}`}</h2>
          </div>
          <Tabs
            colorScheme="lipadGreen"
            variant="line"
            size="lg"
            isFitted
            isLazy
          >
            <TabList>
              {tabs.map((e, i) => (
                <Tab key={i}>
                  <h2 className="text-center text-sm font-medium">{e}</h2>
                </Tab>
              ))}
            </TabList>

            <TabPanels>
              <TabPanel padding={0}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {(props) => (
                    <form
                      onSubmit={props.handleSubmit}
                      className="mt-4 flex flex-col gap-2 text-sm sm:text-base"
                    >
                      <MobileInputField
                        name="mobileNumber"
                        type="tel"
                        label="Mobile number"
                        placeholder="XXX XXX XXX"
                        flag={ui.selectedCountry?.flag}
                        phoneCode={ui.selectedCountry?.phone_code}
                      />
                      <InputField
                        name="amount"
                        type="number"
                        disabled={
                          payload.client_data.checkout_configs
                            ?.checkout_settings.allow_split_payments === 1
                            ? false
                            : true
                        }
                        label={`Amount (${
                          payload.merchant_site_data.running_amounts
                            .converted_currency ??
                          payload.merchant_site_data.running_amounts
                            .origin_currency_code
                        })`}
                        placeholder="100"
                      />
                      <CheckBox
                        name="saveNumber"
                        label="Save my information for faster checkout"
                      />
                      <div className="mt-4 w-full">
                        <SolidButton type="submit" label="Confirm Details" />
                      </div>
                    </form>
                  )}
                </Formik>
              </TabPanel>
              {/* {checkout.payment_method_code == "MPESA_KEN" && ( // Original conditional rendering, commented out */}
              {/* Conditionally render the "How to Pay" tab panel - Commented out as requested */}
              {/* {showHowToPayTab && ( */}
              {/* <TabPanel> */}
              {/*   <div className="space-y-2"> */}
              {/*     <h2 className="font-medium">Payment Instructions</h2> */}
              {/*     <ol className="list-decimal px-4"> */}
              {/*       {listOfInstruction.map((step, index) => ( */}
              {/*          <li key={index}> */}
              {/*           {renderInstructionStep(step, payload)} */}
              {/*         </li> */}
              {/*       ))} */}
              {/*     </ol> */}
              {/*     <div className="w-full pt-2"> */}
              {/*       <SolidButton */}
              {/*         label="Confirm Payment" */}
              {/*         onClick={() => { */}
              {/*           setCheckout((prevState) => ({ */}
              {/*             ...prevState, */}
              {/*             client_service_code: */}
              {/*               payload.merchant_site_data.client_service */}
              {/*                 .client_service_code, */}
              {/*             payer_msisdn: formatPhoneNumber( */}
              {/*               initialPhoneNumber, */}
              {/*               ui.selectedCountry.phone_code */}
              {/*             ), */}
              {/*             request_amount: */}
              {/*               payload.merchant_site_data.running_amounts */}
              {/*                 .converted_balance ?? */}
              {/*               payload.merchant_site_data.running_amounts */}
              {/*                 .origin_balance, */}
              {/*           })); */}
              {/*           navigate("/process-payment", { */}
              {/*             state: { */}
              {/*               payment_method_type: "mobile_money", */}
              {/*               timeout: 3000, */}
              {/*             }, */}
              {/*           }); */}
              {/*         }} */}
              {/*       /> */}
              {/*     </div> */}
              {/*   </div> */}
              {/* </TabPanel> */}
              {/* )} */}
            </TabPanels>
          </Tabs>
        </div>
        <BottomSection />
      </div>
    </Container>
  );
}

export default MobileMoneyPage;
